import styled from "styled-components";

export const TransportCardWrapper = styled.div`
.shipment-container {
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    .shipment-card {
    border: 2px solid #ECEFF1;
    border-radius: 4px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background-color: #F5FBFF;
    &.active{
      border: 2px solid #1565D8;
      background-color: #ffff;
      cursor: pointer;

    }
    grid-row-gap: 4px;
    .shipment-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 4px;
    span.shipment-title {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #1565D8;
}
}
p.shipment-address {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #4E5969;
}
}
}
`;
